export default __webpack_public_path__ + "static/media/Shemite Mercenary Leggings.c705b4ad.jpg";